import React, { PureComponent } from 'react';
import styled from 'styled-components';
import _ from "lodash";
import { batchRequest, getRequest, postRequest, putRequest } from '../../api/ApiService';
import { changeLocation } from '../../api/Location';
import { isSurveyFinished } from '../../api/Surveys';
import { teamsEndpoint } from '../../api/Teams';
import Auth from '../../routes/Auth';

import DecisionsAlert from '../../components/alerts/decisions';

import { Loader } from 'react-loaders';

import Navigation from '../components/peer-feedback/components/navigation';
import Pagination from '../components/peer-feedback/components/pagination';

import BiggestTakeaway from '../components/peer-feedback/pages/dynamics/team/biggest-takeaway';
import DoDifferently from '../components/peer-feedback/pages/dynamics/team/do-differently';
import TheTeam from '../components/peer-feedback/pages/dynamics/team/the-team';
import TeamDynamics from '../components/peer-feedback/pages/dynamics/team/team-dynamics';
import TeamDynamicsPerformance from '../components/peer-feedback/pages/dynamics/team/team-dynamics-performance';

import TheIndividual from '../components/peer-feedback/pages/dynamics/individual/the-individual';
import MostLeastValuablePlayers from '../components/peer-feedback/pages/dynamics/individual/most-least-valuable-players';
import SelfAssessment from '../components/peer-feedback/pages/dynamics/individual/self-assessment';
import PeerRating from '../components/peer-feedback/pages/dynamics/individual/peer-rating';
import Inclusiveness from '../components/peer-feedback/pages/dynamics/individual/inclusiveness';
import DominantPersonalities from '../components/peer-feedback/pages/dynamics/individual/dominant-personalities';

import StrengthsAndAreasOfDevelopment from '../components/peer-feedback/pages/skills-assessment/strengths-and-areas-of-development';
import TeamworkSkills from '../components/peer-feedback/pages/skills-assessment/teamwork-skills';

import ThatsAll from '../components/peer-feedback/pages/thats-all';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 794px;
  background: #f5f6f7;

  ${p => p.wideContentWrapper && `
    width: 100%;
    max-width: 1240px;
  `}
`;

class InstructorPeerFeedback extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      loaded: false,
      round: {},
      roundId: 0,
      showPeerFeedbackPages: true,
      finishedSurveys: [],
      lastFinishedSurvey: {},
      surveysTeamScore: {},
      surveysStatsByUser: {},
      playersCompletedSurveysCount: 0,
      gamesTeamplayers: [],
      teams: [],
      surveysStatsByTeam: [],
      surveysStats: []
    };
  }

  componentWillMount() {
    const { rounds } = this.props;
    const activeRound = this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));

    const roundId = round ? round.id : 0;
    this.setState({
      round,
      roundId
    });
  }

  componentDidMount() {
    this.loadNavigation(() => {
      this.updateCurrentState();
    });
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return Number(roundInUrl || currentRound);
  }

  get activeSurvey() {
    const { location } = this.props;
    const { lastFinishedSurvey } = this.state;
    const surveyInUrl = _.get(location, 'query.survey', null);

    return surveyInUrl || lastFinishedSurvey.stage;
  }

  fetchGamesTeamplayers = async (nextPage) => {
    let nextPageAvailable = true;
    let gamesTeamplayers = [];
    let nextPageUrl = nextPage;

    while (nextPageAvailable) {
      nextPageAvailable = false;
      await getRequest(
        nextPageUrl
      )
        // eslint-disable-next-line no-loop-func
        .then(res => {
          nextPageUrl = res.body.next;
          nextPageAvailable = nextPageUrl;
          gamesTeamplayers.push(...res.body.results);
        })
        .catch(err => { });
    }

    return gamesTeamplayers;
  }

  loadNavigation(callback) {
    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/?course=${Auth.getCourseId()}`,
    ).then(async res => {
      const surveys = res.body.results;
      const finishedSurveys =
        surveys && surveys.length > 0
          ? surveys.filter(i => isSurveyFinished(i))
          : [];
      const lastFinishedSurvey =
        finishedSurveys.length > 0
          ? finishedSurveys[finishedSurveys.length - 1]
          : null;

      const lastFinishedSurveyStage = lastFinishedSurvey ? lastFinishedSurvey.stage : 0;

      const activeSurvey = this.activeSurvey ? this.activeSurvey : lastFinishedSurveyStage;
      const activeFinishedSurvey = finishedSurveys.find(survey => survey.stage === activeSurvey);
      const activeSurveyID = activeFinishedSurvey ? activeFinishedSurvey.id : 0;

      batchRequest([
        `${process.env.REACT_APP_API_URL}v2/forms/surveys/${activeSurveyID}/team-score/`,
        `${process.env.REACT_APP_API_URL}v2/forms/surveys/${activeSurveyID}/stats-by-user/`,
        `${process.env.REACT_APP_API_URL}v2/games/teamplayers/?game=${Auth.getGameId()}`,
        teamsEndpoint(),
        `${process.env.REACT_APP_API_URL}v2/forms/surveys/${activeSurveyID}/stats-by-team/`,
        `${process.env.REACT_APP_API_URL}v2/forms/surveys/${activeSurveyID}/stats/`,
      ]).then(async res => {
        const surveysTeamScore = res[0].body;
        const surveysStatsByUser = res[1].body;

        let gamesTeamplayers = res[2].body.results;
        const nextPageAvailable = res[2].body.next;
        if (nextPageAvailable) {
          const newGamesTeamplayers = await this.fetchGamesTeamplayers(nextPageAvailable);
          gamesTeamplayers.push(...newGamesTeamplayers);
        }

        const teams = res[3].body;
        const surveysStatsByTeam = res[4].body;

        const playersCompletedSurveysCount = surveysStatsByUser.filter(i => {
          return i.evaluation_completed === true
        }).length;

        let showPeerFeedbackPages = true;
        if (
          !surveysTeamScore
          || Object.keys(surveysTeamScore).length === 0
          || surveysTeamScore.detail === 'Not found.'
        ) {
          showPeerFeedbackPages = false;
        }

        const showBiggestTakeaway = !!activeFinishedSurvey.questions.find(i => i.text.toLowerCase().includes('biggest takeaway'));
        const showDoDifferently = !!activeFinishedSurvey.questions.find(i => i.text.toLowerCase().includes('chance to do it all over again'));

        const surveysStats = res[5].body;
        const surveysStatsIndividualAssessmentQuestions = surveysStats.filter(surveyStats => (
          surveyStats.question_text.toLowerCase().indexOf('having relevant knowledge, skills, and abilities') > -1
          || surveyStats.question_text.toLowerCase().indexOf('handling conflicts') > -1
        ));

        const surveyQuestions = surveys.flatMap(survey => survey.questions);
        const showSkillsAssessment = !!surveyQuestions.find(surveyQuestion => surveyQuestion.category === 'other');

        const navigation = [
          {
            title: 'Dynamics',
            pattern: '/instructor/peer-feedback/dynamics',
            steps: []
          },
          {
            parent: 'Dynamics',
            title: 'Team',
            pattern: '/instructor/peer-feedback/team',
            steps: [
              ...(showBiggestTakeaway ? [
                {
                  url: '/instructor/peer-feedback/team/biggest-takeaway',
                  component: BiggestTakeaway,
                }
              ] : []),
              ...(showDoDifferently ? [
                {
                  url: '/instructor/peer-feedback/team/do-differently',
                  component: DoDifferently,
                }
              ] : []),
              {
                url: '/instructor/peer-feedback/team/the-team',
                component: TheTeam,
              },
              {
                url: '/instructor/peer-feedback/team/team-dynamics',
                component: TeamDynamics,
              },
              {
                url: '/instructor/peer-feedback/team/team-dynamics-performance',
                component: TeamDynamicsPerformance,
              },
            ]
          },
          {
            parent: 'Dynamics',
            title: 'Individual',
            pattern: '/instructor/peer-feedback/individual',
            steps: [
              {
                url: '/instructor/peer-feedback/individual/the-individual',
                component: TheIndividual,
              },
              {
                url: '/instructor/peer-feedback/individual/most-least-valuable-players',
                component: MostLeastValuablePlayers,
              },
              ...(surveysStatsIndividualAssessmentQuestions.length ? [
                {
                  url: '/instructor/peer-feedback/individual/self-assessment',
                  component: SelfAssessment,
                },
              ] : []),
              {
                url: '/instructor/peer-feedback/individual/peer-rating',
                component: PeerRating,
              },
              {
                url: '/instructor/peer-feedback/individual/inclusiveness',
                component: Inclusiveness,
              },
              {
                url: '/instructor/peer-feedback/individual/dominant-personalities',
                component: DominantPersonalities,
              },
            ]
          },
          ...(showSkillsAssessment ? [
            {
              title: 'Skills Assessment',
              pattern: '/instructor/peer-feedback/skills-assessment',
              steps: [
                {
                  url: '/instructor/peer-feedback/skills-assessment/intro',
                  component: StrengthsAndAreasOfDevelopment,
                },
                {
                  url: '/instructor/peer-feedback/skills-assessment/radar-map',
                  component: TeamworkSkills,
                },
              ]
            },
          ] : []),
          {
            title: 'That’s All!',
            pattern: '/instructor/peer-feedback/thats-all',
            steps: [
              {
                url: '/instructor/peer-feedback/thats-all',
                component: ThatsAll,
              }
            ]
          },
        ];

        if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
          this.setState({
            navigation,
            loaded: true,
            showPeerFeedbackPages,
            finishedSurveys,
            lastFinishedSurvey,
            surveysTeamScore,
            surveysStatsByUser,
            playersCompletedSurveysCount,
            gamesTeamplayers,
            teams,
            surveysStatsByTeam,
            surveysStats
          }, () => {
            if (callback) {
              callback();
            }
          });
        } else {
          if (callback) {
            callback();
          }
        }
      })
        .catch(err => { });
    })
      .catch(err => { console.log(err); });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    let currentCategory = 0;
    let currentStep = 0;
    for (let i = 0; i < navigation.length; i++) {
      const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
      if (stepIndex > -1) {
        currentCategory = i;
        currentStep = stepIndex;
        break;
      }
    }

    if (!navigation[currentCategory].steps.length) {
      currentCategory += 1;
    }

    if (
      currentCategory !== this.state.currentCategory
      || currentStep !== this.state.currentStep
    ) {

      this.setState({
        currentCategory,
        currentStep,
      }, () => {
        this.checkLocation();
      });
    } else {
      if (this.props.location.pathname === '/peer-feedback') {
        this.checkLocation();
      }
    }
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;
    const activeSurvey = this.activeSurvey;

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}&survey=${activeSurvey}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  formsSurveysRun = () => {
    const { lastFinishedSurvey } = this.state;
    this.setState({
      loaded: false
    });
    postRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/${lastFinishedSurvey.id}/calc-score/`,
    ).then(() => {
      putRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/survey-view-results/${lastFinishedSurvey.id}/`,
      ).then(() => {
        this.setState({
          loaded: true
        });
      })
        .catch(err => { console.log(err); });
    })
      .catch(err => { console.log(err); });
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      roundId,
      showPeerFeedbackPages,
      finishedSurveys,
      lastFinishedSurvey,
      surveysTeamScore,
      surveysStatsByUser,
      playersCompletedSurveysCount,
      gamesTeamplayers,
      teams,
      surveysStatsByTeam,
      surveysStats
    } = this.state;
    const { rounds, location } = this.props;
    const activeRound = this.activeRound;
    const activeSurvey = this.activeSurvey;

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    const category = navigation[currentCategory].steps.length ? navigation[currentCategory] : navigation[currentCategory + 1];
    let Component = null;
    if (category) {
      Component = category.steps[currentStep].component;
    }

    const modalWindowMessage = <p>{playersCompletedSurveysCount} out of {gamesTeamplayers.length} students completed the peer evaluation (<a target="_black" href="/instructor/teams-roles">view completion list</a>)</p>

    const currentFinishedSurvey = finishedSurveys.find(survey => survey.stage === activeSurvey);

    const wideContentWrapper = (location.pathname.includes('biggest-takeaway') || location.pathname.includes('do-differently'))
      ? true
      : false;

    return (
      <Wrapper>
        <Navigation
          data={navigation}
          category={currentCategory}
          activeRound={activeRound}
        />
        {
          !showPeerFeedbackPages &&
          <DecisionsAlert
            type="info"
            title={`${lastFinishedSurvey.stage[0].toUpperCase() + lastFinishedSurvey.stage.slice(1)} Peer Evaluation Is Now Closed`}
            message={modalWindowMessage}
            buttonText="Process/View Insights"
            buttonCenterAlign={true}
            onHide={this.formsSurveysRun}
          />
        }
        {
          showPeerFeedbackPages &&
          <Content>
            <ContentWrapper wideContentWrapper={wideContentWrapper}>
              {Component && (
                <Component
                  activeRound={activeRound}
                  rounds={rounds}
                  roundId={roundId}
                  surveysTeamScore={surveysTeamScore}
                  surveysStatsByUser={surveysStatsByUser}
                  gamesTeamplayers={gamesTeamplayers}
                  finishedSurveys={finishedSurveys}
                  lastFinishedSurvey={lastFinishedSurvey}
                  teams={teams}
                  surveysStatsByTeam={surveysStatsByTeam}
                  surveysStats={surveysStats}
                  currentFinishedSurvey={currentFinishedSurvey}
                />
              )}
            </ContentWrapper>
            <Pagination
              goNext={this.goNext}
              goPrev={this.goPrev}
              isFirstStep={this.isFirstStep}
              isLastStep={this.isLastStep}
              currentStep={currentStep + 1}
              countOfSteps={this.countOfSteps}
            />
          </Content>
        }
      </Wrapper>
    );
  }

}

export default InstructorPeerFeedback;



// WEBPACK FOOTER //
// ./src/instructor/containers/peer-feedback.js